import React from 'react'
import PropTypes from 'prop-types'
import Link from "../Link/Link"

export default class Logo extends React.Component {
  render() {
    const { uri, text } = this.props

    return (
      <Link
        to={`${uri}`}
        className="logo">
        {text}
      </Link>
    )
  }
}

Logo.defaultProps = {
  uri: '/',
  text: ''
}

Logo.propTypes = {
  uri: PropTypes.string,
  text: PropTypes.string,
}
